export default {
  userProfile: 'users', // "<string>"
  useFirestoreForProfile: true, // <boolean>
}
